import React from 'react';
import {Text} from 'components';

type Props = {
  title: string;
};

export const PrizeTitle: React.FC<Props> = ({title}) => {
  return (
    <Text kind="primary" variant="h1">
      {title}
    </Text>
  );
};
